export default "__VITE_ASSET__fHlSKKm5__"